import get from 'lodash.get';

import { emptyArray } from 'ui-components/default-props/empty';

export const selectRecommendations = (state) => get(state, 'recommendations', emptyArray);
export const selectRecommendationsIsLoading = (state) => get(state, 'isLoading', false);
export const selectRecommendationsHasLoaded = (state) => get(state, 'hasLoaded', false);

export const selectActiveRecommendations = (state) => selectRecommendations(state).filter((r) => !r.isDismissed && !r.isActioned);

export const selectActiveRecommendationByType = (state, { recommendationType }) =>
  selectActiveRecommendations(state).find((r) => r.recommendationType === recommendationType);

export const selectRecommendationByType = (state, { recommendationType }) =>
  selectRecommendations(state).find((r) => r.recommendationType === recommendationType);
